// Consumer PWA wireframe — mock data. FICTIONAL ONLY.
// Never seed this file from the real client list: every name, ID and number below is invented and
// each number uses the reserved 555 block so it cannot belong to a real subscriber.
// NOTE: front-end only. No backend, no real auth, no CSG, no email.

export const C = {
  red: "#E01A2E", redSoft: "#FCD5D8", redInk: "#B01423",
  navy: "#0B1E3B", body: "#F7F5F0", cream: "#EFECE4",
  slate: "#5B6B7E", amber: "#F5A623", green: "#1E9E63", ink: "#1A1E24",
};

export const fmtCell = (v) => {
  const s = String(v).replace(".0", "").trim();
  if (s.length === 11 && s.startsWith("27"))
    return `+27 ${s.slice(2, 4)} ${s.slice(4, 7)} ${s.slice(7)}`;
  return s;
};

// Primary logged-in member (fictional demo persona)
export const USER = {
  name: "Maryanne",
  fullName: "Maryanne Bekker",
  surname: "Bekker",
  idNumber: "9001015555081",
  cell: "27825550188",
  email: "maryanne.bekker@example.co.za",
  insurer: "ResQ1 (Simah)",
  plan: "Family",
  memberSince: "2018",
  place: "12 Sample Avenue, Constantia",
  mapX: 50, mapY: 52,
};

// Household / dependents (fictional demo personas)
export const DEPENDENTS = [
  { name: "Elsa Bekker", role: "Spouse", cell: "27815550117", hasApp: true, activated: true, locationShare: true, mapX: 64, mapY: 34, place: "Cavendish Square, Claremont", lastSeen: "2 min ago", accuracy: "±12m" },
  { name: "Liam Bekker", role: "Son · 21", cell: "27645550164", hasApp: true, activated: true, locationShare: true, mapX: 32, mapY: 66, place: "UCT Upper Campus, Rondebosch", lastSeen: "just now", accuracy: "±8m" },
  { name: "Kai Bekker", role: "Son · 19", cell: "27795550128", hasApp: true, activated: false, locationShare: false },
  { name: "Nina Bekker", role: "Daughter · 17", cell: "27845550196", hasApp: false, activated: false, locationShare: false },
];

export const PROFILE = {
  vehicle: {
    make: "Toyota", model: "Fortuner 2.8 GD-6", year: "2021",
    colour: "Graphite Grey", reg: "CA 000 555",
    tracker: "Netstar · active", notes: "Family SUV — primary vehicle",
  },
  home: {
    address: "12 Sample Avenue, Constantia, Cape Town",
    provider: "Simah Armed Response", alarm: "Paradox · monitored",
    keyholder: "Elsa Bekker", panicPoints: "Bedroom, kitchen, garage",
  },
  medical: {
    bloodType: "O+", allergies: "Penicillin, shellfish",
    conditions: "Type 2 diabetes (managed)", medicalAid: "Demo Health · Classic",
    medicalAidNo: "0000 0000 00", nextOfKin: "Elsa Bekker · +27 81 555 0117",
  },
};

export const NOTICES = [
  { id: "n1", type: "Welcome", title: "Your ResQ1 cover is active", date: "12 Feb 2026", unread: true,
    body: "Welcome to ResQ1 Emergency Protection. Your Family plan is active and your safety net is armed. Press and hold the panic button any time you need help — your location goes straight to our control room." },
  { id: "n2", type: "Action", title: "2 dependents haven't installed the app", date: "10 Feb 2026", unread: true,
    body: "Kai and Nina are on your household but haven't finished setup. Send them an invite so they're protected too — it takes about 20 seconds on their phone." },
  { id: "n3", type: "Notice", title: "Scheduled maintenance · Sun 16 Feb, 02:00–03:00", date: "08 Feb 2026", unread: false,
    body: "We'll be doing routine maintenance on our systems early Sunday morning. The panic button and control-room line remain fully operational throughout." },
  { id: "n4", type: "Product", title: "New: add your medical profile", date: "01 Feb 2026", unread: false,
    body: "You can now store blood type, allergies and medical-aid details so responders have them the moment they reach you. Add yours under Profile → Medical." },
];

export const SELFTEST_STEPS = [
  { t: "Confirm GPS lock", d: "We check that your phone is sharing an accurate location." },
  { t: "Simulate a panic signal", d: "A test signal is sent — no responders are dispatched." },
  { t: "Verify control-room echo", d: "The control room confirms it received your test." },
  { t: "Check household reachability", d: "We confirm your household members' apps are active." },
];

export const SELFTEST_LOG = [
  { date: "05 Feb 2026 · 09:14", result: "pass" },
  { date: "22 Jan 2026 · 18:40", result: "pass" },
  { date: "03 Jan 2026 · 12:02", result: "warn" },
];
